import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Referrals = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <g clipPath="url(#clip0_178_989)">
        <path
          d="M3.99999 13.3915H5.74019C5.96708 13.3915 6.19258 13.4185 6.41253 13.4725L8.25126 13.9193C8.65019 14.0165 9.06586 14.0259 9.469 13.9476L11.502 13.5521C12.039 13.4475 12.5331 13.1903 12.9202 12.8137L14.3586 11.4145C14.7693 11.0156 14.7693 10.3683 14.3586 9.96873C13.9888 9.609 13.4031 9.56847 12.9847 9.87353L11.3084 11.0966C11.0683 11.2721 10.7762 11.3665 10.4758 11.3665H8.85699H9.8874C10.4681 11.3665 10.9386 10.9089 10.9386 10.3439V10.1395C10.9386 9.67033 10.6104 9.26133 10.1427 9.14793L8.5524 8.7612C8.2936 8.6984 8.02853 8.66667 7.76206 8.66667C7.11886 8.66667 5.95459 9.1992 5.95459 9.1992L3.99999 10.0166M1.33333 9.73333V13.6C1.33333 13.9734 1.33333 14.1601 1.40599 14.3027C1.46991 14.4281 1.57189 14.5301 1.69733 14.594C1.83994 14.6667 2.02663 14.6667 2.39999 14.6667H2.93333C3.3067 14.6667 3.49338 14.6667 3.63599 14.594C3.76143 14.5301 3.86341 14.4281 3.92733 14.3027C3.99999 14.1601 3.99999 13.9734 3.99999 13.6V9.73333C3.99999 9.36 3.99999 9.17327 3.92733 9.03067C3.86341 8.90527 3.76143 8.80327 3.63599 8.73933C3.49338 8.66667 3.3067 8.66667 2.93333 8.66667H2.39999C2.02663 8.66667 1.83994 8.66667 1.69733 8.73933C1.57189 8.80327 1.46991 8.90527 1.40599 9.03067C1.33333 9.17327 1.33333 9.36 1.33333 9.73333ZM11.4609 2.39485C11.0631 1.56227 10.1457 1.1212 9.25359 1.54693C8.36153 1.97265 7.98146 2.98227 8.355 3.86856C8.5858 4.41632 9.24713 5.48001 9.71873 6.2127C9.89293 6.48342 9.98006 6.61878 10.1073 6.69793C10.2165 6.76587 10.3531 6.80247 10.4816 6.79827C10.6314 6.79327 10.7745 6.7196 11.0607 6.5723C11.8355 6.17355 12.9401 5.58305 13.4139 5.22409C14.1805 4.64329 14.3704 3.57573 13.7965 2.76417C13.2225 1.95261 12.2218 1.87276 11.4609 2.39485Z"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_178_989">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default withStyles(Referrals);
